import React, { useRef, useEffect } from "react";
import { useDispatch, useStore, useSelector } from "react-redux";
import { setViewer } from "../../store/actions";
import myProviders from "./CustomeProviders";
import { SpinningCircles } from 'react-loading-icons'

import BpmnModeler from "bpmn-js/lib/Modeler";
import "bpmn-js/dist/assets/diagram-js.css";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";

import "./Canvas.css";

const Canvas = ({ children }) => {
  const dispatch = useDispatch();
  const store = useStore();
  const canvasRef = useRef(null);
  const isViewerLoading = useSelector((state) => state.isViewerLoading);

  useEffect(() => {
    let { viewer } = store.getState();

    if (!canvasRef.current) return; // Ensure canvas exists

    if (!viewer) {
      // Initialize the modeler if it's not already set in the store
      viewer = new BpmnModeler({
        container: canvasRef.current,
        keyboard: {
          bindTo: document,
        },
        additionalModules: [myProviders],
      });

      dispatch(setViewer(viewer));
    }

    // Cleanup function: Destroy the modeler when component unmounts
    return () => {
      if (viewer) {
        viewer.destroy();
        dispatch(setViewer(null));
      }
    };
  }, [store, dispatch]);

  return (
    <div id="canvas-container">
      <div
        className="d-flex justify-content-end align-items-center"
        style={{ gap: "7px" }}
      >
        {children}
      </div>
      {isViewerLoading && (
        <div className="canvas-loader-overlay">
          <div className="canvas-loader">
            <SpinningCircles     
              stroke="#595959"
              fill="#595959"
              speed={0.75}
              strokeWidth={5}
              width={100}
              height={100}
            />
          </div>
        </div>
      )}

      <div id="canvas" ref={canvasRef}>
        
      </div>
      <img
        id="floating-logo"
        src="/pubserv/BPMN-Chatbot-Beta/assets/unilogo-gray.png"
        alt="Uni-Logo"
      />
    </div>
  );
};

export default Canvas;
